module.exports = __webpack_public_path__ + "img/slide-29.afe225f5.jpeg";